import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class BusinessCenterService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(adminId, headCenterId, data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.BUSINESS_CENTERS(adminId, headCenterId), data);
    }

    getBusinessCenters(headCenterId, data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.GET_BUSINESS_CENTERS(headCenterId), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.BUSINESS_CENTER_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.BUSINESS_CENTERS(id));
    }

    detailById(id): Observable<any> {
        return this.getRequest(AppUrl.BUSINESS_CENTER_DETAIL_BY_ID(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.BUSINESS_CENTERS(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.BUSINESS_CENTER_UPDATE(id), data);
    }

    updatePassword(id, data): Observable<any> {
        return this.putRequest(AppUrl.BUSINESS_CENTER_PASSWORD(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.BUSINESS_CENTER_STATUS(id), data);
    }

    /*updateProfile(id, data): Observable<any> {
        return this.putRequest(AppUrl.BUSINESS_CENTER_PROFILE_IMAGE(id), data);
    }*/
}
